import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../locales/translations';
import {
  ClassesBookActivitiesStatus,
  ClassesBookItemStatus,
} from '../types/index';

type CourseProgramStatusProps = {
  status: ClassesBookItemStatus | ClassesBookActivitiesStatus;
};

const LABELS = {
  [ClassesBookItemStatus.Associated]: 'statuses.associated', // loaded
  [ClassesBookItemStatus.NonAssociates]: 'statuses.non_associated', // unloaded
  [ClassesBookActivitiesStatus.Loaded]: 'statuses.loaded', // loaded
  [ClassesBookActivitiesStatus.NonLoaded]: 'statuses.non_loaded', // unloaded
};

const BG = {
  [ClassesBookItemStatus.Associated]: '#CEF0DA',
  [ClassesBookItemStatus.NonAssociates]: '#F2C0BD',
  [ClassesBookActivitiesStatus.Loaded]: '#CEF0DA',
  [ClassesBookActivitiesStatus.NonLoaded]: '#F2C0BD',
};

const CourseProgramStatus = ({ status }: CourseProgramStatusProps) => {
  const { t } = useTranslation(TranslationsKeys.CLASSES_BOOK_LIST);

  return (
    <div className="d-flex align-items-center justify-content-center">
      <div
        className="d-flex align-items-center justify-content-start"
        style={{ gap: 8, width: 120 }}
      >
        <div
          className="border border-primary"
          style={{ width: 20, height: 20, backgroundColor: BG[status] }}
        />
        <span>{t(LABELS[status])}</span>
      </div>
    </div>
  );
};

export default CourseProgramStatus;
